import { Input } from "./ui/input";
import { Label } from "./ui/label";
import { Switch } from "./ui/switch";
import { Button } from "./ui/button";
import { useState } from "react";
import { Loader2, Trash2 } from "lucide-react";
import { toast } from "sonner";
import api, { formatApiError } from "../lib/api";
import { DemoUsersPanel } from "./DemoUsersPanel";

const toIt = (d) => (d ? d.toLocaleDateString("it-IT", { day: "2-digit", month: "2-digit", year: "numeric" }) : "—");

const calcScadenza = (f) => {
  if (f.demo_scadenza_tipo === "giorni") {
    const n = parseInt(f.demo_scadenza_giorni, 10);
    if (!n || n < 1) return null;
    const base = f.demo_attivato_at ? new Date(f.demo_attivato_at) : new Date();
    const d = new Date(base.getFullYear(), base.getMonth(), base.getDate());
    d.setDate(d.getDate() + n);
    return d;
  }
  if (!f.demo_scadenza_data) return null;
  const [y, m, dd] = f.demo_scadenza_data.split("-").map(Number);
  return new Date(y, m - 1, dd);
};

const CleanupButton = ({ tenantId }) => {
  const [busy, setBusy] = useState(false);
  const run = async () => {
    if (!window.confirm("Eliminare subito TUTTI i dati inseriti dall'utente demo (inclusi gli allegati)? L'operazione è irreversibile.")) return;
    setBusy(true);
    try {
      const { data } = await api.post(`/admin/tenants/${tenantId}/demo-cleanup`);
      toast.success(`Pulizia completata: ${data.deleted} record eliminati`);
    } catch (e) { toast.error(formatApiError(e.response?.data?.detail)); }
    finally { setBusy(false); }
  };
  return (
    <Button type="button" onClick={run} disabled={busy} data-testid="demo-cleanup-now-button" className="bg-red-600 hover:bg-red-700 text-white">
      {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <><Trash2 className="h-4 w-4 mr-1" />Esegui pulizia ora</>}
    </Button>
  );
};

export const DemoSection = ({ form, setForm }) => {
  const set = (k, v) => setForm({ ...form, [k]: v });
  const inp = "mt-1.5 bg-slate-900/60 border-slate-700";
  return (
    <div className="rounded-lg border border-slate-800 bg-slate-900/40 px-4 py-3 space-y-3" data-testid="demo-settings">
      <div className="flex items-center justify-between">
        <div>
          <div className="text-sm text-slate-200">Modalità Demo</div>
          <div className="text-xs text-slate-500">I dati inseriti dagli utenti dello studio vengono cancellati automaticamente.</div>
        </div>
        <Switch checked={form.demo_enabled} onCheckedChange={(v) => set("demo_enabled", v)} data-testid="edit-demo-enabled" className="data-[state=checked]:bg-amber-500" />
      </div>
      {form.demo_enabled && (
        <div className="pt-3 border-t border-slate-800 space-y-3" data-testid="demo-section">
          <p className="text-xs font-semibold uppercase tracking-wider text-slate-500 font-mono">Demo</p>
          <div>
            <Label className="text-slate-300">Giorni prima della cancellazione automatica dei dati</Label>
            <Input type="number" min={1} step={1} value={form.demo_retention_days} onChange={(e) => set("demo_retention_days", e.target.value)}
              data-testid="edit-demo-retention" className={inp} />
          </div>
          <div>
            <Label className="text-slate-300">Scadenza accesso demo</Label>
            <div className="flex gap-4 mt-1.5 text-sm text-slate-300">
              {[["data", "Data specifica"], ["giorni", "Giorni dall'attivazione"]].map(([v, l]) => (
                <label key={v} className="flex items-center gap-1.5 cursor-pointer">
                  <input type="radio" name="demo-scad-tipo" checked={form.demo_scadenza_tipo === v} onChange={() => set("demo_scadenza_tipo", v)}
                    data-testid={`edit-demo-tipo-${v}`} className="accent-amber-500" />{l}
                </label>
              ))}
            </div>
            {form.demo_scadenza_tipo === "data" ? (
              <Input type="date" value={form.demo_scadenza_data} onChange={(e) => set("demo_scadenza_data", e.target.value)}
                data-testid="edit-demo-scadenza-data" className={inp} />
            ) : (
              <Input type="number" min={1} step={1} value={form.demo_scadenza_giorni} onChange={(e) => set("demo_scadenza_giorni", e.target.value)}
                data-testid="edit-demo-scadenza-giorni" placeholder="Numero di giorni" className={inp} />
            )}
          </div>
          <div className="text-sm text-slate-300" data-testid="demo-scadenza-riepilogo">
            Scadenza demo calcolata: <span className="font-semibold text-amber-400">{toIt(calcScadenza(form))}</span>
          </div>
          {form.demo_attivato_at && <DemoUsersPanel tenantId={form.id} codice={form.demo_codice} password={form.demo_password} />}
          {form.demo_attivato_at ? <CleanupButton tenantId={form.id} /> : (
            <p className="text-xs text-slate-500" data-testid="demo-cleanup-hint">Salva lo studio in modalità demo per abilitare la pulizia manuale.</p>
          )}
        </div>
      )}
    </div>
  );
};
